import moment from 'moment-timezone';

export const FIVE_MIN = 5;
export const FIFTEEN_MIN = 15;
export const THIRTY_MIN = 30;
export const HOUR = 60;
export const SIX_HOURS = 60 * 6;
export const DAY = 60 * 24;
export const WEEK = 60 * 24 * 7;
export const MONTH = 60 * 24 * 31;
export const THREE_MONTHS = 60 * 24 * 31 * 3;
export const YEAR = 60 * 24 * 365;
const VIEWER_DRILL_DOWN_LIMIT_DAYS = 60 * 24 * 31;

export const GRANULARITY = {
  PT1M: 'PT1M',
  PT5M: 'PT5M',
  PT15M: 'PT15M',
  PT30M: 'PT30M',
  PT1H: 'PT1H',
  PT6H: 'PT6H',
  PT12H: 'PT12H',
  P1D: 'P1D',
  P1W: 'P1W',
  P1M: 'P1M',
  P30D: 'P30D',
};

export const GRANULARITY_UNIT = {
  [GRANULARITY.PT1M]: 'minute',
  [GRANULARITY.PT1H]: 'hour',
  [GRANULARITY.P1D]: 'day',
};

function getGranularity(from, to, minuteGranularity = true, overview = false) {
  // use minutes otherwise there will be rounding issue
  const diffInMins = moment(to).diff(moment(from), 'minutes');
  let validGranularity;
  let fromTillNow;
  switch (true) {
    case diffInMins <= SIX_HOURS: // Six Hours, added for Overview Dashboard
      fromTillNow = moment().diff(from, 'minutes');
      if (fromTillNow > MONTH) {
        validGranularity = GRANULARITY.PT1H;
      } else {
        validGranularity = minuteGranularity ? GRANULARITY.PT1M : GRANULARITY.PT1H;
      }
      break;
    case diffInMins <= DAY: // <= 1 day
      fromTillNow = moment().diff(from, 'minutes');
      if (fromTillNow > MONTH) {
        validGranularity = GRANULARITY.PT1H;
      } else if (overview) {
        validGranularity = GRANULARITY.PT1H;
      } else {
        validGranularity = minuteGranularity ? GRANULARITY.PT1M : GRANULARITY.PT1H;
      }
      break;
    case diffInMins <= MONTH: // > 1 day and <= 1 month
      validGranularity = GRANULARITY.PT1H;
      break;
    case diffInMins <= YEAR: // > 1 month and <= 1 year
      validGranularity = GRANULARITY.P1D;
      break;
    default:
      validGranularity = GRANULARITY.P1D;
  }
  return validGranularity;
}

export default getGranularity;

export const moreThanViewerDrillDownLimit = (startTime) =>
  moment().diff(moment(startTime), 'minutes') > VIEWER_DRILL_DOWN_LIMIT_DAYS;
